<template>
  <el-menu
    :default-active="selectNavIndex"
    class="el-menu-vertical"
    @open="handleOpen"
    @close="handleClose"
    :collapse="isCollapse"
    :background-color="skinType ? '#1F3269' : '#3F668E'"
    text-color="#fff"
    active-text-color="#ffd04b"
    :router="true"
  >
    <template v-for="(routeInfo, index) of authorizeMenuList.children">
      <el-submenu
        v-if="routeInfo.children"
        :key="index"
        :index="routeInfo.activeIndex ? routeInfo.activeIndex : routeInfo.name"
      >
        <template slot="title">
          <i :class="routeInfo.meta.icon"></i>
          <span>{{ routeInfo.meta ? routeInfo.meta.title : "" }}</span>
        </template>
        <template v-for="(subRoute, order) of routeInfo.children">
          <el-menu-item
            v-show="subRoute.isShow === undefined || subRoute.isShow"
            :key="`subRoute-${order}`"
            :index="subRoute.activeIndex ? subRoute.activeIndex : subRoute.name"
            :route="subRoute"
            ><i :class="subRoute.meta.icon"></i
            >{{ subRoute.meta ? subRoute.meta.title : "" }}
          </el-menu-item>
        </template>
      </el-submenu>
      <el-menu-item
        v-else
        :key="index"
        v-show="routeInfo.isShow !== false"
        :index="routeInfo.activeIndex ? routeInfo.activeIndex : routeInfo.name"
        :route="routeInfo"
      >
        <i :class="routeInfo.meta.icon"></i>
        <span>{{ routeInfo.meta ? routeInfo.meta.title : "" }}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>
<script>
// import { homeRoute } from '@/router';

export default {
  name: "home-navs",
  props: {
    isCollapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // homeRoute,
      selectNavIndex: "",
    };
  },
  watch: {
    $route(newVal) {
      console.log("newVal", newVal);
    },
  },
  created() {
    this.selectNavIndex = this.getDefaultActiveIndex();
    console.log("this.activeIndex", this.activeIndex);
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
    // 获取功能列表
    authorizeMenuList() {
      return this.$store.getters.authorizeMenuList;
    },
  },
  methods: {
    getDefaultActiveIndex() {
      const { name } = this.$route;
      if (name === "home") {
        return "ligh-map-index";
      }
      const routeInfo = this.findRouteInfo(name, this.authorizeMenuList);
      if (routeInfo) {
        return routeInfo.activeIndex ? routeInfo.activeIndex : routeInfo.name;
      }
      return null;
    },
    findRouteInfo(name, route) {
      if (name === route.name) {
        return route;
      }
      if (route.children) {
        for (let i = 0; i < route.children.length; i += 1) {
          const childRoute = route.children[i];
          const selectRoute = this.findRouteInfo(name, childRoute);
          if (selectRoute) {
            return selectRoute;
          }
        }
      }

      return null;
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>
<style>
.el-menu-vertical {
  min-height: 100%;
}
.el-menu-vertical:not(.el-menu--collapse) {
  width: 200px;
}
.el-submenu__title,
.el-menu-item {
  text-align: left;
}
</style>
